import React from 'react';

const FaceSwapLeftPanel = ({
  t,
  mainTab,
  setMainTab,
  activeTab,
  setActiveTab,
  options,
  promptText,
  onPromptChange,
  generationSettingsNode,
  onRandomSelection,
  onClearAll,
  selectedOptions,
  onOptionChange,
  isGenerating,
  generationProgress,
  canGenerate,
  toolCost,
  onGenerate
}) => {
  const renderOptions = () => {
    const activeCategory = options.find(option => option.key === activeTab);
    if (!activeCategory) return null;

    return (
      <div className="options">
        {activeCategory.children.map(child => (
          <div key={child.key} className="option-item">
            <label>{t(child.name)}</label>
            <div className="custom-select">
              <select
                value={selectedOptions[child.key] || ''}
                onChange={(e) => onOptionChange(child.key, e.target.value)}
              >
                <option value="">{t('aiWorkbench.faceSwap.options.pleaseSelect')}</option>
                {child.options.map(opt => (
                  <option key={opt.key} value={opt.key}>
                    {t(opt.label)}
                  </option>
                ))}
              </select>
            </div>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="left-panel">
      <div className="main-tabs">
        <button
          className={mainTab === 'text-to-image' ? 'active' : ''}
          onClick={() => setMainTab('text-to-image')}
        >
          {t('aiWorkbench.faceSwap.tabs.textToImage')}
        </button>
        <button
          className={mainTab === 'image-to-image' ? 'active' : ''}
          onClick={() => setMainTab('image-to-image')}
        >
          {t('aiWorkbench.faceSwap.tabs.imageToImage')}
        </button>
      </div>

      {generationSettingsNode}

      <div className="prompt-section">
        <label htmlFor="prompt-textarea">{t('aiWorkbench.faceSwap.prompt.label')}</label>
        <textarea
          id="prompt-textarea"
          placeholder={t('aiWorkbench.faceSwap.prompt.placeholder')}
          value={promptText}
          onChange={(e) => onPromptChange(e.target.value)}
        />
        <div className="prompt-actions">
          <button onClick={onRandomSelection}>{t('aiWorkbench.faceSwap.buttons.random')}</button>
          <button onClick={onClearAll}>{t('aiWorkbench.faceSwap.buttons.clearAll')}</button>
        </div>
      </div>

      <div className="tabs">
        {options.map(option => (
          <button
            key={option.key}
            onClick={() => setActiveTab(option.key)}
            className={`tab-button ${activeTab === option.key ? 'active' : ''}`}
          >
            {t(option.name)}
          </button>
        ))}
      </div>

      {renderOptions()}

      <button
        className={`generate-button ${isGenerating ? 'generating' : ''}`}
        onClick={onGenerate}
        disabled={isGenerating || !canGenerate}
        style={{
          background: isGenerating
            ? `linear-gradient(to right, #00b894 ${Math.round(generationProgress)}%, #666 ${Math.round(generationProgress)}%)`
            : '#00b894'
        }}
      >
        {isGenerating
          ? `${t('aiWorkbench.faceSwap.status.generating')} ${Math.round(generationProgress)}% (${toolCost} ${t('credits.credits')})`
          : `${t('aiWorkbench.faceSwap.buttons.generate')} (${toolCost} ${t('credits.credits')})`}
      </button>
    </div>
  );
};

export default FaceSwapLeftPanel;
